module.exports = {render: function () {with(this){return _c('svg',{staticClass:"ico-face",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-11439 -12423 10.703 22.882","width":"11","height":"23"}},[_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"id":"Union_2","data-name":"Union 2","d":"M2.307 22.882V12.241H0V7.627h2.307V4.614C2.307 4.037 2.179 0 7.18 0h3.52v4.551H7.627a.679.679 0 0 0-.768.768v2.308H10.7l-.768 4.614H6.859v10.641z","transform":"translate(-11439 -12423)"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./static/media/ico-facebook.svg
// module id = K04W
// module chunks = 0